import React, { useEffect, useState } from "react";
import Inner_Footer_Text_Component from "../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import { getAllComplaintHandlingPolicy } from "../../utils/apis/content/content";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useNavigate } from "react-router-dom";

const Complaints_Handling_Policy = () => {
  const [complaintHandlingPolicy, setComplaintHandlingPolicy] = useState("");
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const getComplaintHandlingPolicy = async () => {
    const res = await getAllComplaintHandlingPolicy();
    if (res?.success) {
      setComplaintHandlingPolicy(res.data);
    }
  };

  useEffect(() => {
    getComplaintHandlingPolicy();
  }, []);

  const navigate = useNavigate();

  return (
    <section className="Complaints_Handling_Policy About_Profile">
      <div className="heading_div">
        <div className="row">
          <div className="col-8">
            <p className="info_page_title">Complaints Handling Policy</p>
          </div>
          <div className="col-4 text-end">
            <FontAwesomeIcon
              className="colpa-close"
              icon={faXmark}
              onClick={() => navigate(-1)}
            />
          </div>
        </div>
      </div>

      <div className="info_div">
        <p className="info_text">
          {htmlToReactParser.parse(complaintHandlingPolicy?.name)}
        </p>
      </div>

      <div className="footer_div">
        <Inner_Footer_Text_Component />
      </div>
    </section>
  );
};

export default Complaints_Handling_Policy;
